module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Brunegg-efd43df50e8bfbeb9f5bffe410509d19.svg";